import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
function Stars({
  count,
  size = 14,
  color = '#FBBC04'
}: {
  count: number;
  size?: number;
  color?: string;
}) {
  return <div className="flex gap-0.5" data-id="element-189">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={i < count ? '' : 'opacity-30'} style={{
      width: size,
      height: size,
      fill: i < count ? color : 'transparent',
      color
    }} strokeWidth={0} data-id="element-190" />)}
    </div>;
}
function GoogleLogo() {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" data-id="element-191">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" data-id="element-192" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-193" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" data-id="element-194" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-195" />
    </svg>;
}
function TheKnotBadge() {
  return <div className="flex flex-col items-center gap-2" data-id="element-196">
      {/* The Knot logo mark */}
      <div className="flex items-center gap-2" data-id="element-197">
        <svg width="28" height="28" viewBox="0 0 32 32" fill="none" data-id="element-198">
          <path d="M16 4C10 4 6 8 6 12c0 3 2 5.5 4 7l6 9 6-9c2-1.5 4-4 4-7 0-4-4-8-10-8z" fill="none" stroke="#E8554E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-199" />
          <path d="M12 12c0-2.2 1.8-4 4-4s4 1.8 4 4" fill="none" stroke="#E8554E" strokeWidth="2" strokeLinecap="round" data-id="element-200" />
        </svg>
        <span className="font-serif text-lg font-bold" style={{
        color: '#E8554E'
      }} data-id="element-201">
          The Knot
        </span>
      </div>
      <div className="text-center" data-id="element-202">
        <p className="text-[11px] font-semibold uppercase tracking-wider" style={{
        color: '#E8554E'
      }} data-id="element-203">
          Best of Weddings
        </p>
        <p className="text-xs text-muted mt-0.5" data-id="element-204">2024 Winner</p>
      </div>
    </div>;
}
function WeddingWireBadge() {
  return <div className="flex flex-col items-center gap-2" data-id="element-205">
      <div className="flex items-center gap-2" data-id="element-206">
        <svg width="24" height="24" viewBox="0 0 32 32" fill="none" data-id="element-207">
          <circle cx="16" cy="16" r="12" fill="none" stroke="#00B2A9" strokeWidth="2.5" data-id="element-208" />
          <circle cx="12" cy="14" r="3" fill="none" stroke="#00B2A9" strokeWidth="1.5" data-id="element-209" />
          <circle cx="20" cy="14" r="3" fill="none" stroke="#00B2A9" strokeWidth="1.5" data-id="element-210" />
          <path d="M12 17c0 2.2 1.8 4 4 4s4-1.8 4-4" fill="none" stroke="#00B2A9" strokeWidth="1.5" strokeLinecap="round" data-id="element-211" />
        </svg>
        <span className="font-sans text-base font-bold" style={{
        color: '#00B2A9'
      }} data-id="element-212">
          WeddingWire
        </span>
      </div>
      <div className="text-center" data-id="element-213">
        <p className="text-[11px] font-semibold uppercase tracking-wider" style={{
        color: '#00B2A9'
      }} data-id="element-214">
          Couples' Choice
        </p>
        <p className="text-xs text-muted mt-0.5" data-id="element-215">2024 Award</p>
      </div>
    </div>;
}
function YelpBadge() {
  return <div className="flex flex-col items-center gap-2" data-id="element-216">
      <div className="flex items-center gap-1.5" data-id="element-217">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="#D32323" data-id="element-218">
          <path d="M12.7 2.3c-.4-.4-1-.4-1.4 0L5.6 8c-.4.4-.4 1 0 1.4l.7.7c.4.4 1 .4 1.4 0L12 5.8l4.3 4.3c.4.4 1 .4 1.4 0l.7-.7c.4-.4.4-1 0-1.4L12.7 2.3z" data-id="element-219" />
          <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" data-id="element-220" />
          <path d="M5.6 14.6c-.4-.4-.4-1 0-1.4l.7-.7c.4-.4 1-.4 1.4 0L12 16.8l4.3-4.3c.4-.4 1-.4 1.4 0l.7.7c.4.4.4 1 0 1.4l-5.7 5.7c-.4.4-1 .4-1.4 0L5.6 14.6z" data-id="element-221" />
        </svg>
        <span className="font-sans text-base font-extrabold" style={{
        color: '#D32323'
      }} data-id="element-222">
          yelp
        </span>
      </div>
      <div className="text-center" data-id="element-223">
        <Stars count={5} size={12} color="#D32323" data-id="element-224" />
        <p className="text-xs text-muted mt-1" data-id="element-225">48 Reviews</p>
      </div>
    </div>;
}
export function SocialProof() {
  return <section className="bg-white py-14 md:py-16 px-6 border-y border-copper/10" data-id="element-226">
      <div className="max-w-6xl mx-auto" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-228">
          {/* Label */}
          <p className="text-center text-[10px] md:text-xs tracking-[0.25em] uppercase text-muted mb-10 font-medium" data-id="element-229">
            Recognized & Reviewed
          </p>

          {/* Badges Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-0 md:divide-x md:divide-copper/10" data-id="element-230">
            {/* Google Reviews */}
            <div className="flex flex-col items-center gap-3 md:px-8" data-id="element-231">
              <GoogleLogo data-id="element-232" />
              <div className="flex items-center gap-2" data-id="element-233">
                <span className="font-serif text-2xl font-semibold text-charcoal" data-id="element-234">
                  4.9
                </span>
                <Stars count={5} size={14} data-id="element-235" />
              </div>
              <p className="text-xs text-muted" data-id="element-236">200+ Google Reviews</p>
            </div>

            {/* The Knot */}
            <div className="flex items-center justify-center md:px-8" data-id="element-237">
              <TheKnotBadge data-id="element-238" />
            </div>

            {/* WeddingWire */}
            <div className="flex items-center justify-center md:px-8" data-id="element-239">
              <WeddingWireBadge data-id="element-240" />
            </div>

            {/* Yelp */}
            <div className="flex items-center justify-center md:px-8" data-id="element-241">
              <YelpBadge data-id="element-242" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}